import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-htvdoc',
  templateUrl: './htvdoc.component.html',
  styleUrls: ['./htvdoc.component.scss']
})
export class HtvdocComponent implements OnInit {

  constructor(public authService: AuthService,public router: Router) { }
  url;id_ht;
  id_cliente=10;
  ngOnInit() {
    this.url
    var c=this.router.url;
    var c2=c.split("?");
    
    this.id_ht=Number(c2[1].replace("=",""));
    if(this.id_ht==undefined){
      this.id_ht=0
    }else{
      this.ht();
    }
  }


  simbolo(s){
    if(s==1)return "Si";
    else return "";
  }

  cliente;ht_det;
  async ht(){
      const pdf = new PdfMakeWrapper(); 
      pdf.pageOrientation("landscape");  
      pdf.pageSize("letter")
      var cliente_name="";
      var codigo="";
      var usuario_nombre="";
      var nombre="";
      var fecha="";
      var tot="";
  
 
      
    let  postData1 = {
      id:this.id_ht
    } 
    var id_cliente=0;
    await this.authService.service("/api/get_ht_id",postData1)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
           tot=res.length;
          
          codigo=res[0].codigo;
          nombre=res[0].nombre;
          fecha=res[0].fecha;
          id_cliente=res[0].id_cliente;
          usuario_nombre=res[0].usuario_nombre;   
    });
    //*/
    
    await this.authService.service("/api/get_cliente_by_id",{id:id_cliente})
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.cliente=data;
          cliente_name=this.cliente[0].razonsocial ;
                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
           // swal.fire('¡API incorrecta! exp', '', 'error');
  });
      pdf.add(new Table([             
          [{text:"Cliente: "+cliente_name,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
          {text:"Hoja de Trabajo Estandarizado",alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
          {text:"Código:"+codigo,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        ], 
         ]).widths([220,230,220]).fontSize(10).bold().alignment('left').end);
         
      pdf.add(new Table([             
          [{text:"Realizado por: "+usuario_nombre+" "+fecha,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
          {text:"Nombre de la Actividad:"+nombre,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
          {text:"Revisión:"+tot,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        ], 
         ]).widths([220,230,220]).fontSize(10).bold().alignment('left').end);
  //,"Secuencia mandatoria","Chequeo de calidad","(Que)","Como","Por Que","Tiempo","Imagenes"       
  var wdth1=[10,135,135,135, 24,203];
  var wdth2=[10,40,40,40,40,70,70,70, 24,203];
  var wdt=[]
  var h1=[{text:"No.",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
  {text:"(Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"(Como)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"(Por Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"Tiempo",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"Imagenes",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  ]
  var h2=[{text:"No.",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
  {text:"Seguridad del operador",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"Operacion crítica",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"Secuencia mandatoria",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"Chequeo de calidad",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"(Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"(Como)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"(Por Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"Tiempo",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  {text:"Imagenes",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
  ]
  var bndcompleto=true;
  //console.log("htdet")
  //console.log(localStorage.getItem("tpdf_ht"))
  
  if(localStorage.getItem("tpdf_ht")=="1"){bndcompleto=true
  }else{bndcompleto=false}
  var head=[]
  if(bndcompleto){ 
    wdt= wdth1;
    head=h1;
  }
  else{
    wdt= wdth2;
    head=h2;
  }
      pdf.add(new Table([ head]).widths(wdt).fontSize(7).bold().alignment('left').end);
  
       let  postData = {
          id:this.id_ht
        } 
        await this.authService.service("/api/get_ht_det",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);     
              this.ht_det=data;
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                //swal.fire('¡API incorrecta! exp', '', 'error');
            });
            
            
            //{image: this.img_g5,  width: 91,height:102  ,alignment:'center'  }
           // console.log(this.ht_det);
            for(var i=0 ;i<this.ht_det.length;i++){
              var im1=Array();
              var im2=Array();
              var im3=Array();
              var im4=Array();
              
              if(this.ht_det[i].img1!=null){            
                await this.authService.service("/api/img_g4",{img:this.ht_det[i].img1})
                          .then(
                            data => {
                              var dat = JSON.stringify(data);
                              var res = JSON.parse(dat);                              
                              im1=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }]
                          },
                          error => {
                              var de= JSON.stringify(error);
                              var di = JSON.parse(de)    
                          });
                  }
                  if(this.ht_det[i].img2!=null){
                  await this.authService.service("/api/img_g4",{img:this.ht_det[i].img2})
                            .then(
                              data => {
                                var dat = JSON.stringify(data);
                                var res = JSON.parse(dat);  
                                im2=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }];
                            },
                            error => {
                                var de= JSON.stringify(error);
                                var di = JSON.parse(de)    
                            });
                    }
                    if(this.ht_det[i].img3!=null){
                    await this.authService.service("/api/img_g4",{img:this.ht_det[i].img3})
                              .then(
                                data => {
                                  var dat = JSON.stringify(data);
                                  var res = JSON.parse(dat);  
                                  im3=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }]
                              },
                              error => {
                                  var de= JSON.stringify(error);
                                  var di = JSON.parse(de)    
                              });
                    }
                    if(this.ht_det[i].img4!=null){
                      await this.authService.service("/api/img_g4",{img:this.ht_det[i].img4})
                                .then(
                                  data => {
                                    var dat = JSON.stringify(data);
                                    var res = JSON.parse(dat);  
                                    im4=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }]
                                },
                                error => {
                                    var de= JSON.stringify(error);
                                    var di = JSON.parse(de)    
                                });
                      }
              //console.log(im);
              if(im1.length==0){im1.push([{text:""}]);}
              if(im2.length==0){im2.push([{text:""}]);}
              if(im3.length==0){im3.push([{text:""}]);}
              if(im4.length==0){im4.push([{text:""}]);}
              var c1=[[{text:i+1,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
              {text:this.ht_det[i].principal,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.ht_det[i].importante,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.ht_det[i].razon,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.ht_det[i].tiempo,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},                      
                new Table([
                        [im1,im2],
                        [im3,im4]
                      ]).layout("noBorders").end            
              ]]
              var c2=[[
                {text:i+1,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
                {text:this.simbolo(this.ht_det[i].simbolo1),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
                {text:this.simbolo(this.ht_det[i].simbolo2),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
                {text:this.simbolo(this.ht_det[i].simbolo3),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
                {text:this.simbolo(this.ht_det[i].simbolo4),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
                {text:this.ht_det[i].principal,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
                {text:this.ht_det[i].importante,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
                {text:this.ht_det[i].razon,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
                {text:this.ht_det[i].tiempo,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},                            
                new Table([[im1,im2],[im3,im4]]).layout("noBorders").end              
              ]]
              var c3=[]
              if(bndcompleto){c3=c1;}
              else{c3=c2;}
              pdf.add(new Table(c3).widths(wdt).fontSize(7).bold().alignment('left').end);            
          
             }
            //console.log("hoja de trabajo");            
      pdf.create().download(nombre+'.pdf');  
      setTimeout(function(){
        window.close();
      },4000);//
  
    

    
  }

}
